import type { PropsWithChildren } from "react";

export default function CheckoutContainer({ children }: PropsWithChildren) {
  return (
    <section className="border-gray-150 relative flex flex-1 flex-col divide-y border-b md:pb-12">
      {children}
    </section>
  );
}
